import {
  initializeFaro,
  getWebInstrumentations,
  SessionInstrumentation,
  FetchTransport,
  LogLevel,
} from '@grafana/faro-web-sdk';
import { environment } from '../environments/environment';

export function faroInitializer(): () => Promise<void> {
  return async () => {
    initializeFaro({
      app: {
        name: environment.grafana.appName,
        version: '1.56.0',
        environment: environment.grafana.env,
      },
      transports: [new FetchTransport({ url: environment.grafana.url })],
      instrumentations: [
        ...getWebInstrumentations({
          enablePerformanceInstrumentation: true,
        }),
        new SessionInstrumentation(),
      ],
      consoleInstrumentation: {
        // DEBUG is never forwarded, on any environment. angular-auth-oidc-client
        // at `LogLevel.Debug` logs the access token verbatim ("storing the
        // accessToken '<jwt>'") and the whole token response, refresh_token
        // included — all through `console.debug`. Forwarding that would ship
        // live credentials to Grafana, so the OIDC debug trail stays in the
        // browser where it is needed.
        disabledLevels: environment.production
          ? [LogLevel.DEBUG, LogLevel.INFO, LogLevel.LOG]
          : [LogLevel.DEBUG],
        consoleErrorAsLog: false,
      },
      trackResources: false,
      sessionTracking: {
        enabled: true,
        persistent: true,
        maxSessionPersistenceTime: 1000 * 60 * 30,
        onSessionChange: (oldS, newS) => {
        },
      },
    });
  };
}
